import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { loginUser } from 'src/store/features/auth/authActions'

const useLogin = () => {
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const dispatch = useDispatch<AppDispatch>()

  function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value)
  }

  function handlePasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
    setPassword(e.target.value)
  }

  function handleLoginSubmit(e: React.SyntheticEvent) {
    e.preventDefault()
    dispatch(
      loginUser({
        email,
        password,
      }),
    )
  }

  return {
    email,
    password,
    handleEmailChange,
    handlePasswordChange,
    handleLoginSubmit,
  }
}

export default useLogin
